export default {
	controls: {
		next: "Próximo",
		prev: "Anterior",
		done: "Concluir",
		progressSeparator: "de",
	},
	welcome: {
		title: "Bem-vindo ao ORI!",
		description: "O ORI é um sistema de gestão espiritual para templos. Vamos fazer um tour rápido pelos módulos do sistema para você conhecer tudo que está disponível.",
		recommended: "Altamente recomendado",
		start: "Iniciar Tour Guiado",
		skip: "Pular por agora",
	},
	helpPanel: {
		title: "Ajuda da Página",
		rewatchTour: "Rever Tour Guiado",
	},
	guided: {
		assistant: {
			title: "Assistente virtual",
			description: "E sempre que precisar de ajuda, fale com o assistente. Ele tira dúvidas, mostra onde clicar e ajuda a configurar o terreiro passo a passo — é só clicar neste botão a qualquer momento.",
		},
		dashboard: {
			title: "Dashboard",
			description: "Página inicial do sistema. Aqui você vê um resumo rápido: seus dados, o ritual ativo no momento, agendados, gráficos rápidos e os aniversariantes.",
		},
		consultants: {
			title: "Consulentes",
			description: "Pessoas que frequentam o templo para receber atendimento espiritual. Cadastre, busque e gerencie todos os consulentes.",
		},
		mediums: {
			title: "Médiuns",
			description: "Membros do corpo mediúnico do templo. Gerencie o cadastro de médiuns, funções e linhas espirituais. Adicione uma jornada ao consulente para integrar a corrente.",
		},
		journeyStages: {
			title: "Etapas da Jornada",
			description: "Estágios pelos quais uma pessoa passa no templo (ex: Visitante, Iniciado, Desenvolvido). Cada pessoa pode estar em uma etapa.",
		},
		functions: {
			title: "Funções",
			description: "Papéis que os médiuns exercem nos rituais (ex: Cambono, Ogã, Pai/Mãe de Santo). Associe funções às pessoas.",
		},
		memberGroups: {
			title: "Grupos",
			description: "Organize pessoas em grupos para facilitar a gestão. Crie grupos por finalidade (ex: Grupo de Estudo, Corrente de Cura) e atribua membros.",
		},
		spiritualLines: {
			title: "Linhas Espirituais",
			description: "Linhas espirituais que trabalham na casa. Ex: Linha de Pretos Velhos, Linha de Caboclos, Linha das Crianças.",
		},
		guides: {
			title: "Guias Espirituais",
			description: "Entidades que atendem as pessoas no templo. Cadastre os guias e associe-os às pessoas para manter o registro espiritual.",
		},
		orixas: {
			title: "Orixás",
			description: "Divindades cultuadas no templo. Cadastre os orixás e associe-os às pessoas para registrar a coroa e as ligações espirituais.",
		},
		attendanceTypes: {
			title: "Tipos de Ficha",
			description: "Categorias de atendimento disponíveis (ex: Consulta, Passe, Descarrego). Você cria de acordo com a necessidade de sua casa. Posteriormente estas fichas são vinculadas aos rituais.",
		},
		ritualTypes: {
			title: "Tipos de Rituais",
			description: "Categorias de rituais praticados no templo (ex: Gira de Caboclo, Sessão de Cura). Cada ritual criado é associado a um tipo.",
		},
		rituals: {
			title: "Rituais",
			description: "Rituais realizados no templo. Crie, inicie, gerencie e encerre rituais. Cada ritual gera fichas, chamadas e registros de atendimento.",
		},
		financialDashboard: {
			title: "Financeiro",
			description: "Painel financeiro do templo. Acompanhe receitas, despesas e o saldo geral. Visão consolidada de toda a movimentação financeira.",
		},
		financialFunds: {
			title: "Caixas",
			description: "Gerencie os caixas/fundos do templo. Crie fundos, registre contribuições e acompanhe as movimentações de entrada.",
		},
		financialMovements: {
			title: "Movimentações",
			description: "Histórico completo de todas as movimentações financeiras do templo. Filtre por período, caixa, tipo e status.",
		},
		financialReports: {
			title: "Relatórios Financeiros",
			description: "Relatórios detalhados da situação financeira. Fechamentos mensais, balanços e análises por período.",
		},
		templeSettings: {
			title: "Configurações do Templo",
			description: "Edite os dados do templo, contato, endereço, funcionamento e identidade visual. Configure impressão, e-mail, atendimento e financeiro.",
		},
		templeUsers: {
			title: "Usuários",
			description: "Veja quem tem acesso ao sistema, seus papéis (Dono, Admin, Membro) e status de atividade.",
		},
		templeInvites: {
			title: "Convites",
			description: "Envie convites por e-mail para novas pessoas acessarem o sistema. Acompanhe o status de cada convite.",
		},
		wisdomQuotes: {
			title: "Frases de Sabedoria",
			description: "Gerencie frases de sabedoria exibidas no dashboard e nas mensagens do templo. Adicione, edite ou desative frases.",
		},
		billing: {
			title: "Plano e Assinatura",
			description: "Consulte o plano atual do templo, período de teste e informações de assinatura.",
		},
		displayMessages: {
			title: "Mensagens do Display",
			description: "Gerencie as mensagens exibidas na ORI TV. Crie avisos, lembretes e comunicados para exibir no display do templo.",
		},
		import: {
			title: "Importação",
			description: "Importe dados em massa para o sistema. Envie planilhas com cadastros de pessoas para agilizar a migração.",
		},
		support: {
			title: "Suporte",
			description: "Canal direto com a equipe do ORI. Abra chamados para dúvidas, sugestões ou problemas técnicos e acompanhe o status.",
		},
	},
	pages: {
		Dashboard: "O Dashboard é a página inicial do sistema. Aqui você vê um resumo rápido: seus dados, o ritual ativo no momento, agendados, gráficos rápidos e os aniversariantes.",
		Consultants: "Consulentes são as pessoas que frequentam o templo para receber atendimento espiritual. Aqui você cadastra, busca e gerencia todos os consulentes.",
		Mediums: "Médiuns são os membros do corpo mediúnico do templo. Aqui você gerencia o cadastro de todos os médiuns, incluindo funções e linhas espirituais. Adicione uma jornada ao consulente para integrar a corrente.",
		SpiritualLines: "Linhas espirituais que trabalham na casa. Ex: Linha de Pretos Velhos, Linha de Caboclos, Linha das Crianças.",
		Guides: "Guias espirituais são entidades que atendem as pessoas no templo. Cadastre os guias e associe-os às pessoas para manter o registro espiritual.",
		Orixas: "Orixás são as divindades cultuadas no templo. Cadastre os orixás e associe-os às pessoas para registrar a coroa e as ligações espirituais.",
		RitualTypes: "Tipos de rituais definem as categorias de rituais praticados no templo. Cada ritual criado é associado a um tipo.",
		Rituals: "Rituais realizados no templo. Aqui você cria, inicia, gerencia e encerra os rituais. Cada ritual gera fichas, chamadas e registros de atendimento.",
		JourneyStages: "Etapas da jornada representam os estágios pelos quais uma pessoa passa no templo. Cada pessoa pode estar em uma etapa.",
		Functions: "Funções definem os papéis que os médiuns exercem nos rituais. Associe funções às pessoas para organizar o corpo mediúnico.",
		MemberGroups: "Grupos permitem organizar pessoas por finalidade. Crie grupos, adicione membros e gerencie atribuições coletivas.",
		AttendanceTypes: "Categorias de atendimento disponíveis (ex: Consulta, Passe, Descarrego). Você cria de acordo com a necessidade de sua casa. Posteriormente estas fichas são vinculadas aos rituais.",
		FinancialDashboard: "Painel financeiro do templo. Acompanhe receitas, despesas e o saldo geral. Visão consolidada de toda a movimentação financeira.",
		FinancialFunds: "Gerencie os caixas/fundos do templo. Crie fundos, registre contribuições e acompanhe as movimentações de entrada.",
		FinancialMovements: "Histórico completo de todas as movimentações financeiras do templo. Filtre por período, caixa, tipo e status.",
		FinancialReports: "Relatórios detalhados da situação financeira. Fechamentos mensais, balanços e análises por período.",
		TempleSettings: "Configurações do templo permitem editar os dados, contato, endereço, funcionamento e identidade visual. Configure impressão, e-mail, atendimento e financeiro.",
		TempleUsers: "Gerenciamento de usuários do templo. Veja quem tem acesso ao sistema, seus papéis e status de atividade.",
		TempleInvites: "Sistema de convites do templo. Envie convites por e-mail para novas pessoas acessarem o sistema.",
		WisdomQuotes: "Frases de sabedoria exibidas no dashboard e nas mensagens do templo. Adicione, edite ou desative frases.",
		Billing: "Consulte o plano atual do templo, período de teste e informações de assinatura.",
		DisplayMessages: "Gerencie as mensagens exibidas na ORI TV. Crie avisos, lembretes e comunicados para exibir no display do templo.",
		Import: "Importe dados em massa para o sistema. Envie planilhas com cadastros de pessoas para agilizar a migração.",
		Support: "Canal direto com a equipe do ORI. Abra chamados para dúvidas, sugestões ou problemas técnicos e acompanhe o status.",
	},
};
